import React from 'react';
import { Box, Typography, Button, SelectChangeEvent } from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';

interface AddSimModalProps {
    serviceProviderOptions: { id: string; label: string }[];
    serviceProvider: string;
    setServiceProvider: (val: string) => void;
    selectedFile: File | null;
    handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddSimModal: React.FC<AddSimModalProps> = ({
    serviceProviderOptions,
    serviceProvider,
    setServiceProvider,
    selectedFile,
    handleFileChange
}) => {
        const handleDownloadFormat = () => {
        const link = document.createElement('a');
        link.href = '/sim_number_bulk_upload.csv'; 
        link.download = 'sim_number_upload_format.csv'; 
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1, pb: 1 }}>
            <Box>
                <Dropdown 
                    options={serviceProviderOptions}
                    selectedValue={serviceProvider}
                    handleChange={(event: SelectChangeEvent<string>) => setServiceProvider(event.target.value)}
                    placeholder="Select Service Provider"
                    label="Service Provider"
                    height="40px"
                    width="190px" 
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Button variant="outlined" component="label" sx={{ textTransform: 'none' }}>
                    Choose File
                    <input type="file" hidden accept=".csv, .xlsx, .xls" onChange={handleFileChange} />
                </Button>
                <Typography variant="body2" color="textSecondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {selectedFile ? selectedFile.name : 'No file chosen'}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
                <Button variant="outlined" onClick={handleDownloadFormat} color="inherit" sx={{ height: '40px', minWidth: '120px', borderRadius: '4px' }}>
                    Format
                </Button>
            </Box>
        </Box>
    );
};

export default AddSimModal;